module.exports = __webpack_public_path__ + "img/2016.1bc4f32c.jpg";